module.exports = __webpack_public_path__ + "img/img-carousel-3.fc3192a8.jpeg";